// extracted by mini-css-extract-plugin
module.exports = {"answersButton":"ExtendedAnswersButton_answersButton__2AocA","answers":"ExtendedAnswersButton_answers__3sVg7"};